import { gql } from '@apollo/client';

import { UI_DEPTH } from '../../constants/message';
import { TopicBodyFragment } from '../api/topic';
import {
  ChildMessageMetaFragment,
  ChildMessageRelevanceFragment,
  generateChildren,
  generateParent,
  ThreadMessageFragment,
} from '../ThreadMessages/query';

const INITIAL_PARENTS_LOADED = 1;
const EXTRA_PARENTS_LOADED = 5;

export const DiscussionQuery_1 = makeDiscussionQuery(INITIAL_PARENTS_LOADED);
export const DiscussionQuery_6 = makeDiscussionQuery(INITIAL_PARENTS_LOADED + EXTRA_PARENTS_LOADED);

export function makeDiscussionQuery(nbParentsLoaded = INITIAL_PARENTS_LOADED) {
  return gql`
query DiscussionQuery_${nbParentsLoaded}($slug: String, $messageId: ID!) {
  website {
    id
    findTopic(slug: $slug) {
      ...TopicBodyFragment
      findOrCreateThread(offset: 0, limit: 0, sort: "relevance", messageId: $messageId) {
        id
        positionLevelCommentInDiscussionYakli
        rootYakliMessage {
          ...ThreadMessageFragment
          ${generateChildren(UI_DEPTH, 'relevance')}
        }
      }
    }
    findMessage(messageId: $messageId) {
      ...ThreadMessageFragment
      ${generateChildren(UI_DEPTH, 'relevance')}
      ${generateParent(nbParentsLoaded, 'relevance')}
    }
  }
}
${ThreadMessageFragment}
${TopicBodyFragment}
${ChildMessageMetaFragment}
${ChildMessageRelevanceFragment}
`;
}

export const ParentMessageQuery = gql`
query ParentMessageQuery($messageId: ID!) {
  website {
    id
    findMessage(messageId: $messageId) {
      id
      ...ThreadMessageFragment
      ${generateParent(EXTRA_PARENTS_LOADED, 'relevance')}
      ${generateChildren(UI_DEPTH, 'relevance')}
    }
  }
}
${ThreadMessageFragment}
${ChildMessageMetaFragment}
${ChildMessageRelevanceFragment}
`;
